import React from 'react';
import PropTypes from 'prop-types';
import { Text, Box } from '@nerdwallet/currency';

import styles from './featured-badge.module.less';

const FeaturedBadge = ({ className, label }) => (
  <div className={className}>
    <Box className={styles.featured}>
      <Text size="small">{label}</Text>
    </Box>
  </div>
);

FeaturedBadge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

FeaturedBadge.defaultProps = {
  className: '',
  label: 'Featured',
};

export default FeaturedBadge;
